import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';

import marketPlaceLogo from './market-place-logo.svg';

import './style.scss';

export default function Header() {
  const { formatMessage } = useIntl();
  const [isWindowContentScrolled, setIsWindowContentScrolled] = useState(false);
  const headerRef = useRef<HTMLInputElement>(null);

  const handleScroll = () => {
    if (headerRef.current) {
      setIsWindowContentScrolled(
        document.documentElement.getBoundingClientRect().top >= 0 ? false : true
      );
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className={`marketplace_header${
        isWindowContentScrolled ? ' sticky' : ''
      }`}
      ref={headerRef}
    >
      <div className="marketplace_header__cotainer">
        <a href="/app-gallery" className="marketplace_header__logo">
          <img src={marketPlaceLogo} alt="" />
        </a>
        <div className="marketplace_header__link">
          <Link className="header-link" to="/app-gallery">
            {formatMessage({ id: 'app_gallery_app_gallery' })}
          </Link>
        </div>
      </div>
    </div>
  );
}
